const initialState = {
  list: [],
  historyList: [],
  selectedItem: null,
  loading: 'idle',
  historyLoading: 'idle',
};

export default initialState;
